export const ChevronRight = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 8 13" {...props}>
    <path
      d="M5.17146 6.5007L0.22168 1.55093L1.6359 0.136719L7.99986 6.5007L1.6359 12.8646L0.22168 11.4504L5.17146 6.5007Z"
      fill="currentColor"
    />
  </svg>
);
